import { TInitialState } from '~/src/features/tariffBuilder/reducer';

import getBaseTv from './getBaseTv';
import selectIsAllowToShowTvPackets from './selectIsAllowToShowTvPackets';

const getBaseTvItem = (state: TInitialState) => {
    const [firstBaseTv] = getBaseTv(state);
    const isAllowToShowTvPackets = selectIsAllowToShowTvPackets(state);
    const [baseTvItem] = Object.values(firstBaseTv.items);

    return {
        ...baseTvItem,
        isSelected: baseTvItem.isSelected,
        disabled: isAllowToShowTvPackets,
    };
};

export default getBaseTvItem;
